// extracted by mini-css-extract-plugin
module.exports = {"section":"why-utilities-run-voltaware_section__T5Kkn","wrapper":"why-utilities-run-voltaware_wrapper__2qKKO","list":"why-utilities-run-voltaware_list__13rOJ"};